module.exports = global["$"] = require("-!/app/node_modules/expose-loader/index.js?jQuery!./jquery-2.2.3.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./public/javascripts/jquery-2.2.3.js-exposed
// module id = 80
// module chunks = 0